import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

import { RoleContext } from "../RoleContext";

import { Tabs, Tab, Box } from "@mui/material";

import TableSmall from "./../Theme/TableSmall.js";
import Table from "./../Theme/Table.js";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../modal.css";

import HospitalForm from "./Lookup/HospitalForm.js";
import SpecialityForm from "./Lookup/SpecialityForm.js";
import QuestionForm from "./Lookup/QuestionForm.js";
import AmbulanceCompanyForm from "./Lookup/AmbulanceCompanyForm.js";
import SeverityLevelForm from "./Lookup/SpecialityLevelModal.js";

import DeleteConfirmation from "../deleteConfirmation.js";
import { STATUS } from "../enum.js";
import FirstAidGuideForm from "./Lookup/FirstAidGuideForm";
import AdditionalSupportForm from "./Lookup/AdditionalSupportForm";

const AmbulanceLookup = () => {

    const roleData = useContext(RoleContext);
    var role = JSON.parse(roleData);

    const [currentTab, setCurrentTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    }

    const [hospitals, setHospitals] = useState([]);
    const [speciality, setSpeciality] = useState([]);
    const [questions, setQuestions] = useState([]);

    const [singleHospital, setSingleHospital] = useState([]);
    const [singleSpeciality, setSingleSpeciality] = useState([]);
    const [singleQuestion, setSingleQuestion] = useState([]);

    const [hospitalId, setHospitalId] = useState(null);
    const [specialityId, setSpecialityId] = useState(null);
    const [questionId, setQuestionId] = useState(null);

    const [displayAddHospital, setDisplayAddHospital] = useState(false);
    const [displayAddSpeciality, setDisplayAddSpeciality] = useState(false);
    const [displayAddQuestion, setDisplayAddQuestion] = useState(false);

    const [displayEditHospital, setDisplayEditHospital] = useState(false);
    const [displayEditSpeciality, setDisplayEditSpeciality] = useState(false);
    const [displayEditQuestion, setDisplayEditQuestion] = useState(false);

    const [displayDeleteHospital, setDisplayDeleteHospital] = useState(false);
    const [displayDeleteSpeciality, setDisplayDeleteSpeciality] = useState(false);
    const [displayDeleteQuestion, setDisplayDeleteQuestion] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState(null);

    const [ambulanceCompanies, setAmbulanceCompanies] = useState([]); 
    const [singleAmbulanceCompany, setSingleAmbulanceCompany] = useState({});  
    const [ambulanceCompanyId, setAmbulanceCompanyId] = useState(null);  

    const [displayAddAmbulanceCompany, setDisplayAddAmbulanceCompany] = useState(false);  
    const [displayEditAmbulanceCompany, setDisplayEditAmbulanceCompany] = useState(false);  
    const [displayDeleteAmbulanceCompany, setDisplayDeleteAmbulanceCompany] = useState(false);

    const [displayAddSupport, setDisplayAddSupport] = useState(false);

    const TabPanel = ({ children, value, index }) => {
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`tabpanel-${index}`}
                aria-labelledby={`tab-${index}`}
            >
                {value === index && <Box p={3}>{children}</Box>}
            </div>
        );
    };

    const getHospitals = async () => {
        const response = await axios.get("hospitals/").then().catch((err) => {
            console.log(err);
        });

        setHospitals(response.data);
    }

    const getSpeciality = async () => {
        const response = await axios.get("speciality/").then().catch((err) => {
            console.log(err);
        });

        setSpeciality(response.data);
    }

    const getQuestions = async () => {
        const response = await axios.get("questions/").then().catch((err) => {
            console.log(err);
        });

        setQuestions(response.data);
    }

    const getAmbulanceCompanies = async () => {
        try {
            const token = localStorage.getItem('d4uToken');
            const response = await axios.get("/ambulance-companies", {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            setAmbulanceCompanies(response.data || []);
        } catch (err) {
            console.log(err);
            setAmbulanceCompanies([]);
        }
    };
    

    const showAddHospital = () => {
        setSingleHospital({});
        setDisplayAddHospital(true);
    }

    const hideAddHospital = () => {
        setDisplayAddHospital(false);
    }

    const showEditHospital = (id) => {
        setHospitalId(id);
        axios.get("/hospitals/" + id, {}).then((res) => {
            setSingleHospital(res.data)
            setDisplayEditHospital(true);
        })
    }
    const hideEditHospital = () => {
        setDisplayEditHospital(false);
    }

    const showAddSpeciality = () => {
        setDisplayAddSpeciality(true);
    }

    const hideAddSpeciality = () => {
        setDisplayAddSpeciality(false);
    }

    const showEditSpeciality = (id) => {
        setSpecialityId(id);
        axios.get("/speciality/" + id, {}).then((res) => {
            setSingleSpeciality(res.data)
            setDisplayEditSpeciality(true);
        })
    }

    const hideEditSpeciality = () => {
        setDisplayEditSpeciality(false);
    }

    const showAddQuestion = () => {
        setDisplayAddQuestion(true);
    }

    const hideAddQuestion = () => {
        setDisplayAddQuestion(false);
    }

    const showEditQuestion = (id) => {
        setQuestionId(id);
        axios.get("/questions/" + id, {}).then((res) => {
            console.log(res.data, "RES");
            setSingleQuestion(res.data)
            setDisplayEditQuestion(true);
        })
    }

    const hideEditQuestion = () => {
        setDisplayEditQuestion(false);
    }


    const showDeleteHospitalModal = (id) => {
        setHospitalId(id);
        setDeleteMessage(`Are you sure you want to delete this hospital?`);
        setDisplayDeleteHospital(true);
    }

    const hideDeleteHospitalModal = () => {
        getHospitals();
        setDisplayDeleteHospital(false);
    }

    const showDeleteSpecialityModal = (id) => {
        setSpecialityId(id);
        setDeleteMessage(`Are you sure you want to delete this speciality?`);
        setDisplayDeleteSpeciality(true);
    }

    const hideDeleteSpecialityModal = () => {
        getSpeciality();
        setDisplayDeleteSpeciality(false);
    }

    const showDeleteQuestionModal = (id) => {
        setQuestionId(id);
        setDeleteMessage(`Are you sure you want to delete this question?`);
        setDisplayDeleteQuestion(true);
    }

    const hideDeleteQuestionModal = () => {
        getQuestions();
        setDisplayDeleteQuestion(false);
    }

    const deleteHospital = (id) => {
        axios.delete("/hospitals/" + id, {}).then((res) => {
            toast.success("Deleted Successfully");
            getHospitals();
        })
        getHospitals();
        setDisplayDeleteHospital(false);
    }

    const deleteSpeciality = (id) => {
        axios.delete("/speciality/" + id, {}).then((res) => {
            toast.success("Deleted Successfully");
            getSpeciality();
        })
        getSpeciality();
        setDisplayDeleteSpeciality(false);
    }

    const deleteQuestion = (id) => {
        axios.delete("/questions/" + id, {}).then((res) => {
            toast.success("Deleted Successfully");
            getQuestions();
        })
        getQuestions();
        setDisplayDeleteQuestion(false);
    }


    const showAddAmbulanceCompany = () => {
        setSingleAmbulanceCompany({});
        setDisplayAddAmbulanceCompany(true);
    };
    
    const hideAddAmbulanceCompany = () => {
        setDisplayAddAmbulanceCompany(false);
    };
    
    const showEditAmbulanceCompany = (id) => {
        setAmbulanceCompanyId(id);
        axios.get(`/ambulance-companies/${id}`).then((res) => {
            setSingleAmbulanceCompany(res.data);
            setDisplayEditAmbulanceCompany(true);
        });
    };
    
    const hideEditAmbulanceCompany = () => {
        setDisplayEditAmbulanceCompany(false);
    };
    
    const showDeleteAmbulanceCompanyModal = (id) => {
        setAmbulanceCompanyId(id);
        setDeleteMessage(`Are you sure you want to delete this ambulance company?`);
        setDisplayDeleteAmbulanceCompany(true);
    };
    
    const hideDeleteAmbulanceCompanyModal = () => {
        getAmbulanceCompanies();
        setDisplayDeleteAmbulanceCompany(false);
    };
    
    const deleteAmbulanceCompany = (id) => {
        axios.delete(`/ambulance-companies/${id}`).then((res) => {
            toast.success("Deleted Successfully");
            getAmbulanceCompanies();
        });
        setDisplayDeleteAmbulanceCompany(false);
    };
    

    useEffect(() => {
        getHospitals();
        getSpeciality();
        getQuestions();
        getAmbulanceCompanies();
    }, [])

    const edit = "ambulanceLookup";
    const detail = "viewambulanceLookup";

    const hospitalColumns = React.useMemo(
        () => [

            {
                Header: "Hospital Lookup",
                columns: [{
                    Header: "Name",
                    accessor: "name",
                    disableFilters: true
                },
                {
                    Header: "Phone",
                    accessor: "phoneNumber",
                    disableFilters: true

                },
                {
                    Header: "Branch Name",
                    accessor: "branchName",
                    disableFilters: true

                },
                {
                    Header: "Latitude",
                    accessor: "latitude",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <span>{value ? parseFloat(value).toFixed(2) : "N/A"}</span>
                    ),
                },
                {
                    Header: "Longitude",
                    accessor: "longitude",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <span>{value ? parseFloat(value).toFixed(2) : "N/A"}</span>
                    ),
                },

                ],
            },
            {
                Header: " ",
                columns: [
                    {
                        Header: "Actions",
                        accessor: "actions",
                        disableFilters: true,
                        Cell: (row) => (
                            <div>
                                <Link to={`/hospital/${row.cell.row.original.hospital_id}`}>
                                    <i className="fas fa-eye success" />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <Link
                                    to={""}
                                    onClick={() => {
                                        showEditHospital(row.cell.row.original.hospital_id);
                                    }}
                                >
                                    <i className="fas fa-edit info" />
                                </Link>
                                &nbsp;
                                &nbsp;
                                {role.filter(function (e) {
                                    return e.perm_name === "delete_hospital";
                                }).length > 0 && (
                                        <Link
                                            to={""}
                                            onClick={(e) => showDeleteHospitalModal(row.cell.row.original.hospital_id)}
                                        >
                                            <i className="fas fa-trash error" />
                                        </Link>
                                    )}
                                {/* <Link
                                    to={""}
                                    onClick={() => {
                                        setHospitalId(row.original.id);
                                        showEditHospital();
                                    }}
                                >
                                    <Badge
                                        badgeContent={"Delete"}
                                        color="error"
                                        overlap="circular"
                                    >
                                        {" "}
                                    </Badge>
                                </Link> */}
                            </div>
                        )
                    },

                ],
            }
        ]
    )

    const specialityColumns = React.useMemo(
        () => [

            {
                Header: "Speciality Lookup",
                columns: [{
                    Header: "Name",
                    accessor: "name",
                    disableFilters: true
                },

                ],
            },
            {
                Header: " ",
                columns: [
                    {
                        Header: "",
                        accessor: "spacerStart1",
                        disableFilters: true,
                        Cell: () => <div style={{ flexGrow: 1 }}></div>,
                    },
                ],
            },
            {
                Header: " ",
                columns: [
                    {
                        Header: "",
                        accessor: "spacerStart2",
                        disableFilters: true,
                        Cell: () => <div style={{ flexGrow: 1 }}></div>,
                    },
                ],
            },
            {
                Header: " ",
                columns: [
                    {
                        Header: "Actions",
                        accessor: "actions",
                        disableFilters: true,
                        Cell: (row) => (
                            <div>
                                <Link to={`/speciality/${row.cell.row.original.specialty_id}`}>
                                    <i className="fas fa-eye success" />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <Link
                                    to={""}
                                    onClick={() => {
                                        showEditSpeciality(row.cell.row.original.specialty_id);

                                    }}
                                >
                                    <i className="fas fa-edit info" />
                                </Link>
                                &nbsp;
                                &nbsp;
                                {role.filter(function (e) {
                                    return e.perm_name === "delete_specialty";
                                }).length > 0 && (
                                        <Link
                                            to={""}
                                            onClick={(e) => showDeleteSpecialityModal(row.cell.row.original.specialty_id)}
                                        >
                                            <i className="fas fa-trash error" />
                                        </Link>
                                    )}
                                {/* <Link
                                    to={""}
                                    onClick={() => {
                                        setHospitalId(row.original.id);
                                        showEditHospital();
                                    }}
                                >
                                    <Badge
                                        badgeContent={"Delete"}
                                        color="error"
                                        overlap="circular"
                                    >
                                        {" "}
                                    </Badge>
                                </Link> */}
                            </div>
                        )
                    },

                ],
            }
        ]
    )

    const questionColumns = React.useMemo(() => [
        {
            Header: "Questions",
            columns: [
                {
                    Header: "Question",
                    accessor: "text",
                    disableFilters: true
                },
                {
                    Header: "Type",
                    accessor: "type",
                    disableFilters: true, 
                    Cell: ({value}) => (
                        <span>{value === 100 ? "Yes/No" : "Multiple Choice"}</span>
                    )
                }
            ]
        },
        {
            Header: "Actions",
            accessor: "actions",
            disableFilters: true,
            Cell: (row) => (
                <div>
                    <Link to={`/question/${row.cell.row.original.question_id}`}>
                        <i className="fas fa-eye success" />
                    </Link>
                    &nbsp;
                    &nbsp;
                    <Link to={""} onClick={() => showEditQuestion(row.cell.row.original.question_id)}>
                        <i className="fas fa-edit info" />
                    </Link>
                    &nbsp;
                    &nbsp;
                    <Link to={""} variant="danger" onClick={() => showDeleteQuestionModal(row.cell.row.original.question_id)}>
                        <i className="fas fa-trash error" />
                    </Link>
                </div>
            ),
        },
    ]);

const ambulanceCompanyColumns = React.useMemo(
        () => [
            {
                Header: "Ambulance Company Lookup",
                columns: [
                    // { Header: "ID", accessor: "company_id", disableFilters: true },
                    { Header: "Company Name", accessor: "company_name", disableFilters: true },
                    { Header: "Classification", accessor: "institution_classification", disableFilters: true },
                    { Header: "Subcity", accessor: "subcity", disableFilters: true },
                    { Header: "Woreda", accessor: "woreda", disableFilters: true },
                    { Header: "Location (GIS)", accessor: "location_gis", disableFilters: true },
                    { Header: "Contact Person", accessor: "contact_person", disableFilters: true },
                    { Header: "Contact Email", accessor: "contact_email", disableFilters: true },
                    { Header: "Contact Phone", accessor: "contact_phone", disableFilters: true },
                    { Header: "Alternate Phone", accessor: "contact_phone_2", disableFilters: true },
                    { Header: "Address", accessor: "address", disableFilters: true },
                    { Header: "Branches", accessor: "branches_count", disableFilters: true },
                    { Header: "Provides Ambulance", accessor: "provides_ambulance", disableFilters: true, Cell: ({ value }) => (<span>{value ? 'Yes' : 'No'}</span>) },
                    { Header: "BLS", accessor: "bls_count", disableFilters: true },
                    { Header: "ALS", accessor: "als_count", disableFilters: true },
                    { Header: "Transport-only", accessor: "transport_only_count", disableFilters: true },
                    { Header: "Prehospital Care", accessor: "provides_prehospital", disableFilters: true, Cell: ({ value }) => (<span>{value ? 'Yes' : 'No'}</span>) },
                    { Header: "Staff Roles", accessor: "staff_roles", disableFilters: true, Cell: ({ value }) => (<span>{Array.isArray(value) ? value.join(", ") : ''}</span>) },
                    { Header: "Has Call Center", accessor: "has_call_center", disableFilters: true, Cell: ({ value }) => (<span>{value ? 'Yes' : 'No'}</span>) },
                    { Header: "Documents", accessor: "documents", disableFilters: true, Cell: ({ value }) => (<span>{Array.isArray(value) ? value.join(", ") : ''}</span>) },
                    { Header: "Wants to Join", accessor: "wants_to_join", disableFilters: true, Cell: ({ value }) => (<span>{value ? 'Yes' : 'No'}</span>) },
                    { Header: "Submission Date", accessor: "submission_date", disableFilters: true },
                    { Header: "Agreed To Terms", accessor: "agreed_to_terms", disableFilters: true, Cell: ({ value }) => (<span>{value ? 'Yes' : 'No'}</span>) },
                    { Header: "Terms Version", accessor: "terms_version", disableFilters: true },
                    { Header: "Status", accessor: "status", disableFilters: true,
                        Cell: ({ value }) => (
                            <span>
                              {value === 1 ? "Active" : value === 0 ? "Pending" : value === 2 ? "Rejected" : "Unknown"}
                            </span>
                        )
                    },
                    // { Header: "Updated At", accessor: "updatedAt", disableFilters: true },
                    // { Header: "Created At", accessor: "createdAt", disableFilters: true },
                ]
            },
            {
                Header: " ",
                columns: [
                    {
                        Header: "Actions",
                        accessor: "actions",
                        disableFilters: true,
                        Cell: (row) => {
                            const id = row.cell.row.original.company_id;
                            const status = row.cell.row.original.status;
                            return (
                              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                <Link to={""} onClick={() => showEditAmbulanceCompany(id)}>
                                  <i className="fas fa-edit info" />
                                </Link>
                                &nbsp;
                                <Link to={""} onClick={() => showDeleteAmbulanceCompanyModal(id)}>
                                  <i className="fas fa-trash error" />
                                </Link>
                                &nbsp;
                                {status !== 1 && (
                                  <Button size="sm" variant="success" onClick={() => approveCompany(id)}>
                                    Approve
                                  </Button>
                                )}
                                {status !== 2 && (
                                  <Button size="sm" variant="outline-danger" onClick={() => rejectCompany(id)}>
                                    Reject
                                  </Button>
                                )}
                                <Button size="sm" variant="outline-primary" onClick={() => resendActivation(id)}>
                                  Resend Activation
                                </Button>
                              </div>
                            )
                        }
                    }
                ]
            }
        ],
        []
    );

    const approveCompany = async (id) => {
        try {
            const token = localStorage.getItem('d4uToken');
            await axios.post(`/ambulance-companies/${id}/approve`, {}, { headers: { Authorization: `Bearer ${token}` } });
            toast.success('Company approved');
            getAmbulanceCompanies();
        } catch (e) {
            toast.error(e?.response?.data?.msg || 'Approval failed');
        }
    };

    const rejectCompany = async (id) => {
        try {
            const token = localStorage.getItem('d4uToken');
            await axios.post(`/ambulance-companies/${id}/reject`, {}, { headers: { Authorization: `Bearer ${token}` } });
            toast.success('Company rejected');
            getAmbulanceCompanies();
        } catch (e) {
            toast.error(e?.response?.data?.msg || 'Rejection failed');
        }
    };

    const resendActivation = async (id) => {
        try {
            const token = localStorage.getItem('d4uToken');
            await axios.post(`/ambulance-companies/${id}/resend-activation`, {}, { headers: { Authorization: `Bearer ${token}` } });
            toast.success('Activation email resent');
        } catch (e) {
            toast.error(e?.response?.data?.msg || 'Failed to resend activation');
        }
    };
    

    return (
        <div className="content-wrappers"  style={{paddingLeft:"20px", marginLeft: "-28px",}} >
            <ToastContainer />
            <br />
            <br />
            <br />

            <section className="content">
                <div className="container-fluid">
                    <Tabs value={currentTab} onChange={handleTabChange}>
                        <Tab label="Hospitals" />
                        <Tab label="Speciality" />
                        <Tab label="Questions" />
                        <Tab label="Ambulance Companies" />
                        <Tab label="First Aid Guides" />
                        <Tab label="Additional Support Needed" />
                    </Tabs>

                    {currentTab === 0 && (
                        <TabPanel value={currentTab} index={0}>
                            <div className="col-6">
                                <div className="card">
                                    <div className="card-header">

                                        <h3 className="card-title">Hospitals</h3>
                                        <Button
                                            onClick={() => showAddHospital()}
                                            className="btn btn-success bt"
                                        >
                                            Add Hospital
                                        </Button>
                                    </div>
                                    <div className="card-body">
                                        <TableSmall columns={hospitalColumns} data={hospitals} edit={edit} detail={detail} />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    )
                    }
                    {currentTab === 1 && (
                        <TabPanel value={currentTab} index={1}>
                            <div className="col-6">
                                <div className="card">
                                    <div className="card-header">

                                        <h3 className="card-title">Speciality</h3>
                                        <Button
                                            onClick={showAddSpeciality}
                                            className="btn btn-success bt"
                                        >
                                            Add Speciality 
                                        </Button>
                                    </div>
                                    <div className="card-body">
                                        <TableSmall columns={specialityColumns} data={speciality} edit={edit} detail={detail} />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    )
                    }
                    {currentTab === 2 && (
                        <TabPanel value={currentTab} index={2}>
                            <div className="col-6">
                                <div className="card">
                                    <div className="card-header">

                                        <h3 className="card-title">Questions</h3>
                                        <Button
                                            onClick={showAddQuestion}
                                            className="btn btn-success bt"
                                        >
                                            Add Questions
                                        </Button>
                                    </div>
                                    <div className="card-body">
                                        <TableSmall columns={questionColumns} data={questions} edit={edit} detail={detail} />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    )}

                    {currentTab === 3 && (  
                        <TabPanel value={currentTab} index={3}>
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Ambulance Companies</h3>
                                        <Button
                                            onClick={() => showAddAmbulanceCompany()}
                                            className="btn btn-success bt"
                                        >
                                            Add Ambulance Company
                                        </Button>
                                    </div>
                                    {/* <div className="card-body"> */}
                                    <div className="card-bodys" style={{overflowX: 'auto'}}>
                                        <Table columns={ambulanceCompanyColumns} 
                                        data={ambulanceCompanies} edit={edit} detail={detail} />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    )}

                    {currentTab === 4 && (
                        <TabPanel value={currentTab} index={4}>
                            <div className="col-6">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">First Aid Guides</h3>
                                    </div>
                                    <div className="card-body">
                                        <FirstAidGuideForm />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    )}

                    {currentTab === 5 && (
                        <TabPanel value={currentTab} index={5}>
                            <div className="col-6">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Additional Support Needed</h3>
                                        <Button
                                            onClick={() => setDisplayAddSupport(true)}
                                            className="btn btn-success bt"
                                        >
                                            Add Support
                                        </Button>
                                    </div>
                                    <div className="card-body">
                                        <AdditionalSupportForm showModal={displayAddSupport} hideModal={() => setDisplayAddSupport(false)} />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    )}
                </div>
            </section >

            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                </div>
            </section>


            <HospitalForm
                mode="add"
                showModal={displayAddHospital}
                hideModal={hideAddHospital}
                onSuccess={getHospitals}
            />

            <DeleteConfirmation
                showModal={displayDeleteHospital}
                confirmModal={deleteHospital}
                hideModal={hideDeleteHospitalModal}
                id={hospitalId}
                message={deleteMessage}
            />

            <SpecialityForm
                mode="add"
                showModal={displayAddSpeciality}
                hideModal={hideAddSpeciality}
                onSuccess={getSpeciality}
            />

            <QuestionForm
                mode="add"
                showModal={displayAddQuestion}
                hideModal={hideAddQuestion}
                onSuccess={getQuestions}
            />
  

            <DeleteConfirmation
                showModal={displayDeleteSpeciality}
                confirmModal={deleteSpeciality}
                hideModal={hideDeleteSpecialityModal}
                id={specialityId}
                message={deleteMessage}
            />


            <DeleteConfirmation
                showModal={displayDeleteQuestion}
                confirmModal={deleteQuestion}
                hideModal={hideDeleteQuestionModal}
                id={questionId}
                message={deleteMessage}
            />

            <AmbulanceCompanyForm
                mode="add"
                showModal={displayAddAmbulanceCompany}
                hideModal={hideAddAmbulanceCompany}
                onSuccess={getAmbulanceCompanies}
            />

            <DeleteConfirmation
                showModal={displayDeleteAmbulanceCompany}
                confirmModal={deleteAmbulanceCompany}
                hideModal={hideDeleteAmbulanceCompanyModal}
                id={ambulanceCompanyId}
                message={deleteMessage}
            />


            {
                displayEditHospital == true && (
                    <HospitalForm
                        mode="edit"
                        showModal={displayEditHospital}
                        hideModal={hideEditHospital}
                        initialData={singleHospital}
                        onSuccess={getHospitals}
                    />
                )
            }

            {
                displayEditSpeciality == true && (
                    <SpecialityForm
                        mode="edit"
                        showModal={displayEditSpeciality}
                        hideModal={hideEditSpeciality}
                        initialData={singleSpeciality}
                        onSuccess={getSpeciality}
                    />

                )
            }

            {
                displayEditQuestion == true && (
                    <QuestionForm
                        mode="edit"
                        showModal={displayEditQuestion}
                        hideModal={hideEditQuestion}
                        initialData={singleQuestion}
                        onSuccess={getQuestions}
                    />
                )
            }

            {
                displayEditAmbulanceCompany == true && (
                    <AmbulanceCompanyForm
                        mode="edit"
                        showModal={displayEditAmbulanceCompany}
                        hideModal={hideEditAmbulanceCompany}
                        initialData={singleAmbulanceCompany}
                        onSuccess={getAmbulanceCompanies}
                    />
                )
            }
        </div >
    )
}

export default AmbulanceLookup